import { Injectable } from '@angular/core';
import { AmazonCategoriesGQL, AmazonCategoriesQuery } from 'src/gql/generated';
import { HttpService } from './http.service';
import { gqlErrors } from 'src/app/utils/gql-errors';

@Injectable({
  providedIn: 'root',
})
export class AmazonCategoryService {
  constructor(
    private http: HttpService,
    private amazonCategoriesGQL: AmazonCategoriesGQL,
  ) {}

  public async list(isTop: boolean, success: (resp: AmazonCategoriesQuery) => void, error?: any) {
    const resp = await this.amazonCategoriesGQL.fetch({ variables: { isTop } }).toPromise();
    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp))) {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data);
    }
  }
}
